import script from "./IndustryIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./IndustryIndex.vue?vue&type=script&setup=true&lang=js"

import "./IndustryIndex.vue?vue&type=style&index=0&id=72c22f9e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72c22f9e"]])

export default __exports__